export default "__VITE_ASSET__CyDDsKbA__"